// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Models } from "@hex-insights/app-modules";
import { Address, AddressDeleteMutation } from "../../../Utilities";
import { AddressMutation } from "../../FormUtilities";

export type AddressDeleteButtonProps = Omit<
	Models.DeleteButtonProps<AddressDeleteMutation["deleteAddress"]>,
	"deleteInstance"
> & {
	instanceID: Address["id"];
};

/**
 * A delete button for the Address model.
 */
export function AddressDeleteButton({
	instanceID,
	confirmationContent = "Are you sure you want to delete this address?",
	children = "Delete Address",
	...props
}: AddressDeleteButtonProps) {
	const del = AddressMutation.useDelete(instanceID);

	return (
		<Models.DeleteButton deleteInstance={del} confirmationContent={confirmationContent} {...props}>
			{children}
		</Models.DeleteButton>
	);
}
